import { render, staticRenderFns } from "./CreditClassTeacherBulkSave.vue?vue&type=template&id=4616834a&"
import script from "./CreditClassTeacherBulkSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassTeacherBulkSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassTeacherBulkSave.vue?vue&type=style&index=0&id=4616834a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports